import TFLayoutNavbar from "../Components/TFLayoutNavbar/TFLayoutNavbar";
import TFLayoutFooter from "../Components/TFLayoutFooter/TFLayoutFooter";
import TFLayoutMeta, {
  TFLayoutMetaProps,
} from "../Components/TFLayoutMeta/TFLayoutMeta";
import TFLayoutHero from "../Components/TFLayoutHero/TFLayoutHero";

type LayoutBreadcrumb = {
  title: string;
  href?: string;
  isActive?: boolean;
};
type LayoutBreadcrumbs = LayoutBreadcrumb[];

interface LayoutProps {
  children: React.ReactNode;
  breadcrumbs?: LayoutBreadcrumbs;
  meta?: TFLayoutMetaProps;
  leftPanel?: React.ReactNode;
  leftPanelWidth?: number | string;
  rightPanel?: React.ReactNode;
  rightPanelWidth?: number | string;
}

interface LayoutAsideProps {
  children: React.ReactNode;
  width: number | string;
}
const LayoutAside = ({ children, width }: LayoutAsideProps) => {
  const widthClass = typeof width === "number" ? `${width}px` : width;
  // Navbar (64px) + QuickLinks (48px или 72px на главной) + отступ (16px) = минимум 128px
  return (
    <aside className="lg:flex-shrink-0" style={{ width: widthClass }}>
      <div className="sticky space-y-4" style={{ top: "128px" }}>
        {children}
      </div>
    </aside>
  );
};

const Layout = ({
  children,
  breadcrumbs,
  meta,
  leftPanel,
  leftPanelWidth,
  rightPanel,
  rightPanelWidth,
}: LayoutProps) => {
  const leftWidth = leftPanelWidth || "16rem";
  const rightWidth = rightPanelWidth || "16rem";

  const leftWidthClass =
    typeof leftWidth === "number" ? `${leftWidth}px` : leftWidth;
  const rightWidthClass =
    typeof rightWidth === "number" ? `${rightWidth}px` : rightWidth;

  return (
    <div className="flex flex-col w-full min-h-screen">
      <TFLayoutMeta meta={meta} />
      <TFLayoutNavbar breadcrumbs={breadcrumbs} />

      <div className="w-full min-h-screen">
        <div className="max-w-7xl mx-auto px-4 py-8">
          {/* Hero секция из meta */}
          {meta && meta.icon && (
            <TFLayoutHero
              icon={meta.icon}
              title={meta.title}
              description={meta.description}
            />
          )}

          <div className="flex flex-col lg:flex-row gap-6 mt-6">
            {/* Левая боковая панель */}
            {leftPanel && (
              <LayoutAside width={leftWidthClass}>{leftPanel}</LayoutAside>
            )}

            {/* Основной контент */}
            <main className="flex-1 min-w-0">
              <div className="space-y-8">{children}</div>
            </main>

            {/* Правая боковая панель */}
            {rightPanel && (
              <LayoutAside width={rightWidthClass}>{rightPanel}</LayoutAside>
            )}
          </div>
        </div>
      </div>
      <TFLayoutFooter />
    </div>
  );
};

export default Layout;
